{
  "name": "razor-admin-interface",
  "version": "1.0.1",
  "description": "Angular admin interface for Razor Market Data platform",
  "scripts": {
    "ng": "ng",
    "start": "NODE_OPTIONS=--max_old_space_size=8192 ng serve",
    "start:e2e:ci": "NODE_OPTIONS=--max_old_space_size=4096 NG_BUILD_MAX_WORKERS=1 ng serve --configuration=e2e",
    "build": "NODE_OPTIONS=--max_old_space_size=8192 node scripts/build.mjs",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix",
    "lint:strict": "ng lint --max-warnings 0",
    "sanity-check": "./scripts/build-sanity-check.sh",
    "check-tailwind-ghost-tokens": "if [ -d ../scripts ]; then bash ../scripts/check-tailwind-ghost-tokens.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · GAP-FE guards required. Run from repo root with scripts/, or set ALLOW_GAP_FE_GUARD_SKIP=1 to override (CI/Docker must opt-in explicitly).' >&2; exit 1; fi",
    "check-any-type-io-boundary": "if [ -d ../scripts ]; then bash ../scripts/check-any-type-io-boundary.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-token-regressions": "if [ -d ../scripts ]; then bash ../scripts/check-token-regressions.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-token-d03-d04-w02": "if [ -d ../scripts ]; then bash ../scripts/check-token-d03-d04-w02.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-inline-templates": "if [ -d ../scripts ]; then bash ../scripts/check-inline-templates.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-live-test-safety": "node scripts/check-live-test-safety.mjs && node scripts/check-live-test-safety.mjs --self-test",
    "manifest:generate": "node scripts/generate-fe-test-manifest.mjs && node scripts/generate-fe-api-usage.mjs",
    "test:live:read": "playwright test -c playwright.live.config.ts --project=live-read",
    "test:live:write": "playwright test -c playwright.live.config.ts --project=live-write",
    "redact:artifacts": "node scripts/redact-playwright-artifacts.mjs",
    "manifest:check": "node scripts/check-fe-test-manifest.mjs && node scripts/check-fe-test-manifest.mjs --self-test",
    "check-disabled-e2e": "if [ -d ../scripts ]; then bash ../scripts/check-disabled-e2e.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-spec-compile": "if [ -d ../scripts ]; then bash ../scripts/check-spec-compile.sh; elif [ -n \"$ALLOW_GAP_FE_GUARD_SKIP\" ]; then echo 'gap-fe guards skipped (ALLOW_GAP_FE_GUARD_SKIP set)'; else echo 'BUILD FAIL · gap-fe guards required; set ALLOW_GAP_FE_GUARD_SKIP=1 to override' >&2; exit 1; fi",
    "check-all-gap-fe-guards": "npm run check-tailwind-ghost-tokens && npm run check-any-type-io-boundary && npm run check-token-regressions && npm run check-token-d03-d04-w02 && npm run check-inline-templates && npm run check-disabled-e2e && npm run check-spec-compile && npm run check:cypress-suite && npm run check-live-test-safety && npm run manifest:check",
    "prebuild": "npm run sanity-check && npm run check-all-gap-fe-guards",
    "generate:api-client": "./scripts/generate-api-client.sh",
    "update:api": "npm run generate:api-client && npm run lint:fix",
    "e2e": "ng e2e",
    "prebuild:prod": "npm run sanity-check && npm run check-all-gap-fe-guards",
    "build:prod": "NODE_OPTIONS=--max_old_space_size=8192 node scripts/build.mjs --configuration production --stats-json",
    "postbuild:prod": "./scripts/validate-no-mock-in-prod.sh && node scripts/validate-production-source-maps.mjs && node scripts/analyze-bundle.js --assert-lean-initial-graph --assert-lean-measured-route-graphs --assert-graph-budgets",
    "build:prod:verified": "npm run build:prod && npm run verify:no-mock",
    "verify:no-mock": "./scripts/validate-no-mock-in-prod.sh",
    "verify:angular-config": "node scripts/verify-angular-config.js",
    "audit:pi-icons": "node scripts/audit-pi-icon-names.mjs",
    "audit:pi-icons:test": "node scripts/audit-pi-icon-names.spec.mjs",
    "audit:primeng": "node scripts/audit-primeng-residue.mjs",
    "audit:primeng:test": "node scripts/audit-primeng-residue.spec.mjs",
    "serve:prod": "NODE_OPTIONS=--max_old_space_size=8192 ng serve --configuration production",
    "analyze": "npm run build:prod -- --stats-json && node scripts/analyze-bundle.js",
    "analyze:watch": "node scripts/analyze-bundle.js --watch",
    "perf:build-stats": "npm run build:prod -- --stats-json && node scripts/analyze-bundle.js",
    "perf:runtime": "npm run build:prod && node scripts/runtime-analysis.js",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "cypress:run:chrome": "cypress run --browser chrome",
    "cypress:run:firefox": "cypress run --browser firefox",
    "cypress:run:edge": "cypress run --browser edge",
    "e2e:open": "cypress open --e2e",
    "e2e:run": "cypress run --e2e",
    "e2e:ci": "cypress run --e2e --browser chrome --headless",
    "e2e:record": "cypress run --record --key $CYPRESS_RECORD_KEY",
    "test:e2e": "start-server-and-test start http://localhost:4200 cypress:run",
    "test:e2e:ci": "start-server-and-test start:e2e http://localhost:4200 e2e:ci",
    "test:all": "npm run test && npm run e2e:run",
    "test:coverage": "ng test --code-coverage && cypress run --e2e",
    "test:coverage:fe": "ng test --watch=false --browsers=ChromeHeadlessNoSandbox --code-coverage",
    "check:coverage-report": "node scripts/check-frontend-coverage.mjs --self-test && node scripts/check-frontend-coverage.mjs",
    "check:karma-harness": "node scripts/check-karma-harness.mjs --self-test && node scripts/check-karma-harness.mjs",
    "start:e2e": "ng serve --configuration=e2e",
    "check:a11y-allowlist-expiry": "node scripts/check-a11y-allowlist-expiry.mjs",
    "check:rbac-spec-no-tautology": "node scripts/check-rbac-spec-no-tautology.self-test.mjs && node scripts/check-rbac-spec-no-tautology.mjs",
    "check:mocked-strategy-contracts": "node scripts/check-mocked-strategy-contracts.test.mjs && node scripts/check-mocked-strategy-contracts.mjs",
    "check:legacy-component-imports": "node scripts/check-legacy-component-imports.mjs",
    "check:e2e-static": "npm run check:a11y-allowlist-expiry && npm run check:rbac-spec-no-tautology && npm run check:mocked-strategy-contracts && npm run check:legacy-component-imports",
    "check:playwright-ci-suite": "node scripts/check-playwright-ci-suite.mjs --self-test && node scripts/check-playwright-ci-suite.mjs",
    "check:cypress-suite": "node scripts/check-cypress-suite.mjs && node scripts/check-cypress-suite.mjs --self-test",
    "test:playwright": "npm run check:e2e-static && playwright test",
    "test:playwright:headed": "npm run check:e2e-static && playwright test --headed",
    "test:playwright:debug": "playwright test --debug",
    "test:playwright:report": "playwright show-report",
    "test:playwright:e2e": "RAZOR_PW_REUSE_EXISTING= npm run test:playwright",
    "type-check": "tsc --noEmit",
    "format:check": "prettier --check \"src/**/*.{ts,html,scss,json}\"",
    "format:write": "prettier --write \"src/**/*.{ts,html,scss,json}\"",
    "test:unit": "ng test --watch=false --browsers=ChromeHeadlessNoSandbox",
    "test:integration": "ng test --watch=false --browsers=ChromeHeadlessNoSandbox --suite=integration",
    "test:smoke": "cypress run --spec \"cypress/e2e/smoke/**/*.cy.ts\"",
    "analyze:bundle": "npm run build:prod -- --stats-json && node scripts/analyze-bundle.js",
    "docker:build": "docker build -t razor-admin-interface .",
    "docker:run": "docker run -p 4200:80 razor-admin-interface",
    "docker:compose": "docker-compose up -d",
    "docker:compose:down": "docker-compose down",
    "k8s:deploy": "kubectl apply -f k8s-deployment.yaml",
    "k8s:delete": "kubectl delete -f k8s-deployment.yaml",
    "optimize:components": "node scripts/optimize-components.js",
    "optimize:bundles": "node scripts/reduce-bundle-sizes.js",
    "optimize:images": "node scripts/optimize-images.js",
    "perf:all": "npm run build:prod && npm run analyze",
    "validate:api": "./scripts/validate-api-contract.sh",
    "postinstall": "node scripts/check-karma-harness.mjs",
    "prepare": "husky",
    "e2e:explore": "node e2e/explore/explore.runner.mjs",
    "start:e2e:copilot": "NODE_OPTIONS=--max_old_space_size=8192 NG_BUILD_MAX_WORKERS=1 ng serve --configuration=copilot-e2e --host=127.0.0.1 --port=4215",
    "cypress:copilot": "cypress run --config-file cypress.copilot.config.ts",
    "test:e2e:copilot": "npm run check:copilot-e2e && start-server-and-test start:e2e:copilot http://127.0.0.1:4215 cypress:copilot",
    "check:copilot-e2e": "node --test scripts/copilot-e2e-config.test.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.0.4",
    "@angular/cdk": "^22.0.2",
    "@angular/common": "^22.0.4",
    "@angular/compiler": "^22.0.4",
    "@angular/core": "^22.0.4",
    "@angular/forms": "^22.0.4",
    "@angular/localize": "^22.0.4",
    "@angular/platform-browser": "^22.0.4",
    "@angular/platform-browser-dynamic": "^22.0.4",
    "@angular/router": "^22.0.4",
    "@angular/service-worker": "^22.0.4",
    "@codemirror/commands": "^6.10.1",
    "@codemirror/lang-javascript": "^6.2.4",
    "@codemirror/state": "^6.5.4",
    "@codemirror/theme-one-dark": "^6.1.3",
    "@codemirror/view": "^6.39.11",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/signals": "^21.1.0",
    "@sentry/angular": "^10.56.0",
    "@standard-schema/spec": "^1.1.0",
    "@types/d3-hierarchy": "^3.1.7",
    "angular-svg-icon": "^19.1.1",
    "axios": "^1.13.2",
    "chart.js": "^4.5.1",
    "codemirror": "^6.0.2",
    "d3": "^7.9.0",
    "d3-hierarchy": "^3.1.2",
    "date-fns": "^4.1.0",
    "dompurify": "^3.4.13",
    "echarts": "^6.0.0",
    "lightweight-charts": "^5.2.0",
    "marked": "^16.4.2",
    "mermaid": "^11.16.1",
    "monaco-editor": "^0.52.2",
    "ng2-charts": "^10.0.0",
    "qrcode": "^1.5.4",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "uuid": "^13.0.0",
    "zod": "^4.3.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.0.4",
    "@angular/cli": "^22.0.4",
    "@angular/compiler-cli": "^22.0.4",
    "@axe-core/playwright": "^4.11.3",
    "@cypress/angular": "^4.1.0",
    "@eslint/js": "^10.0.1",
    "@playwright/test": "^1.57.0",
    "@tailwindcss/aspect-ratio": "^0.4.2",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/typography": "^0.5.19",
    "@types/cypress": "^1.1.6",
    "@types/d3": "^7.4.3",
    "@types/dompurify": "^3.2.0",
    "@types/glob": "^9.0.0",
    "@jridgewell/trace-mapping": "0.3.31",
    "@types/jasmine": "^5.1.15",
    "@types/node": "^25.0.8",
    "@types/qrcode": "^1.5.6",
    "@types/uuid": "^11.0.0",
    "@typescript-eslint/eslint-plugin": "^8.53.0",
    "@typescript-eslint/parser": "^8.53.0",
    "angular-eslint": "22.1.0",
    "autoprefixer": "^10.4.23",
    "baseline-browser-mapping": "^2.9.14",
    "cypress": "^15.9.0",
    "cypress-axe": "^1.7.0",
    "eslint": "^10.8.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.5",
    "geist": "^1.3.1",
    "globals": "^17.12.0",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^5.13.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "postcss": "^8.5.6",
    "prettier": "^3.8.0",
    "prettier-plugin-tailwindcss": "^0.7.2",
    "purgecss": "^7.0.2",
    "sharp": "^0.35.3",
    "start-server-and-test": "^2.1.3",
    "tailwind-scrollbar": "^3.1.0",
    "tailwindcss": "^3.4.17",
    "typescript": "^6.0.3",
    "typescript-eslint": "8.65.0",
    "webpack-bundle-analyzer": "^5.1.1",
    "yaml": "^2.8.3"
  },
  "overrides": {
    "karma": {
      "glob": "7.2.3",
      "rimraf": "3.0.2"
    },
    "karma-coverage": {
      "minimatch": {
        "brace-expansion": "5.0.9"
      }
    }
  },
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0",
    "npm": ">=8.0.0"
  }
}
